import ExistingTagsItemBase from './existingTagsItemBase';
import { RupLoader } from 'copyright-clearance-center-common-ui-react';

const ExistingTagsLoader: React.FunctionComponent = () => {
	return (
		<ExistingTagsItemBase sx={{ justifyContent: 'center' }}>
			<RupLoader small />
		</ExistingTagsItemBase>
	);
};

export default ExistingTagsLoader;
